export default __webpack_public_path__ + "tier-list-section.png";